import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=b42ad990&scoped=true&lang=pug&"
import script from "./Aside.vue?vue&type=script&lang=js&"
export * from "./Aside.vue?vue&type=script&lang=js&"
import style0 from "./Aside.styl?vue&type=style&index=0&id=b42ad990&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42ad990",
  null
  
)

export default component.exports